import { useGlobal } from '@/utils/useGlobal';
import EFPicture from '@elem/ui/ef-picture';

import { useEffect, useState } from 'react';

import { icon1, icon2, icon3, icon4 } from './icons/Icons';

import styles from './index.module.scss';

interface ItemType {
    svg: React.ReactElement<React.SVGProps<SVGSVGElement>>;
    title: string;
    desc: string;
}

const MultiSource = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('theProduct.OutperformSection');

    const [enter, setEnter] = useState({
        label: false,
        title: false,
        desc: false,
    });

    const [isPad, setIsPad] = useState(-1);

    const items: ItemType[] = [
        {
            svg: icon1,
            title: t('multi_source_section_title1'),
            desc: t('multi_source_section_desc1'),
        },
        {
            svg: icon2,
            title: t('multi_source_section_title2'),
            desc: t('multi_source_section_desc2'),
        },
        {
            svg: icon3,
            title: t('multi_source_section_title3'),
            desc: t('multi_source_section_desc3'),
        },
        {
            svg: icon4,
            title: t('multi_source_section_title4'),
            desc: t('multi_source_section_desc4'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined' && isPad !== 1) {
            const isPadValue = window.innerWidth < 1024 ? 1 : 0;
            setIsPad(isPadValue);
        }
    }, []);

    // useEffect(() => {
    //     if (typeof window !== 'undefined') {
    //         const aniArr = ['label', 'title', 'desc'];
    //         const scenes: any = {};
    //         // 1. 文字动效
    //         aniArr.forEach((item) => {
    //             const domInfo: HTMLDialogElement | null = document.querySelector(`.${styles.multiSource} .info .${item}`);
    //             if (domInfo) {
    //                 scenes[item] = AniContainer.create({
    //                     triggerElement: domInfo,
    //                     triggerHook: 1,
    //                     offset: domInfo.offsetHeight,
    //                     duration: '150%',
    //                     onEnter: () => setEnter((prev) => ({ ...prev, [item]: true })),
    //                     onLeave: () => setEnter((prev) => ({ ...prev, [item]: false })),
    //                 });
    //             }
    //         });
    //     }
    // }, []);

    return (
        <div className={`${styles.multiSource} GtmModuleData-section`} data-section-id={styles.multiSource} data-section-title={t(`multi_source_title`)}>
            <div className="bg-img">
                <EFPicture
                    src={'https://websiteoss.ecoflow.com/upload/image/1756882932514/MultiSource-pc.png'}
                    srcMobile="https://websiteoss.ecoflow.com/upload/image/1756882790523/MultiSource-h5.png"
                    alt={t('multi_source_title')}
                />
            </div>
            <div className="box">
                <div className="info">
                    <h2 className={`title${enter.title ? ' enter' : ''}`}>{t('multi_source_label')}</h2>
                    <p className={`desc${enter.desc ? ' enter' : ''}`}>{t('multi_source_intro')}</p>
                </div>
                <ul className="items">
                    {items?.map((item: ItemType, k: number) => (
                        <li className="item" key={k}>
                            {item.svg}
                            <div className="item-text">
                                <span className="item-title">{item.title}</span>
                                <span className="item-desc">{item.desc}</span>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default MultiSource;
